exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".data-table .main-table .table[data-v-50290902] {\n  width: 100%;\n  margin-bottom: 0.25rem;\n}\n.data-table .main-table .table thead th[data-v-50290902] {\n  text-align: left;\n  vertical-align: bottom;\n  border-bottom: 2px solid #dee2e6;\n}\n.data-table .main-table .table td[data-v-50290902], .data-table .main-table .table th[data-v-50290902] {\n  vertical-align: top;\n  border-top: 1px solid #dee2e6;\n}", ""]);

// exports
